import React from 'react';
import { describeApproval, type ApprovalLike } from '../../agent/approvalFormat';
import './approval.css';

export function ApprovalDetails({
  approval,
  lookupTarget,
}: {
  approval: ApprovalLike;
  lookupTarget?: (target: string, id: string | undefined) => string | undefined;
}) {
  const detail = describeApproval(approval, lookupTarget);
  return (
    <div className="approval-details">
      <div className="approval-heading">
        <strong>{detail.title}</strong>
        <span className="approval-tool">{detail.toolLabel}</span>
      </div>
      {detail.description && <p className="approval-description">{detail.description}</p>}
      <div className="approval-items">
        {detail.items.map((item, index) => (
          <div className="approval-item" key={index}>
            <div className="approval-item-head">
              <span className="approval-action">{item.action}</span>
              <span className="approval-target">{item.target}</span>
            </div>
            {item.fields.map((field, fieldIndex) => (
              <div className={`approval-field${field.long ? ' is-long' : ''}`} key={fieldIndex}>
                <span>{field.label}</span>
                <pre>{field.value}</pre>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
